"use strict";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import $ from "jquery";
import ActivityStreamHelper from "../helpers/activity_stream";
import Api from "../api/api";
import ApiService from "../services/api_service";
import Blocker from "./blocker";
import "../helpers/carrier";
import CarrierService from "../services/carrier_service";
import CarrierInvoiceHelper from "./../helpers/carrier_invoice";
import CloseReply from "./close_reply";
import DataStoreService from "./data_store_service";
import DashboardReturnParams from "./ui/dashboard_return_params";
import DocumentBrowser from "./react_document_browser";
import DocumentIndexerService from "./document_indexer_service";
import DocumentsService from "./documents_service";
import DocumentInformation from "./indexer/document_information";
import "./indexer/document_types_setter";
import EmailHelper from "../helpers/email_message";
import "./indexer/email_viewer";
import ExceptionSender from "./exception_sender";
import FactorInvoicesService from "./factor_invoices_service";
import "../util/fetch";
import IndexerHeader from "./indexer/indexer_header";
import LoadDetailInformation from "./indexer/load_detail_information";
import LoadsService from "./loads_service";
import MarkEmailCompleteView from "./mark_email_complete_view";
import moment from "moment";
import PaymentInformation from "./indexer/payment_information";
import PresenceList from "./presence";
import ToDashboardWithFilters from "./ui/to_dashboard_with_filters";
import WaitingSpinner from "../components/waiting_spinner";
import { EmailForwarderMixin } from "./email_forwarder";
import { emailService } from "../services/email_service";
import {
  GroupedDocumentBrowserModel,
  GroupIDGroupCreator,
  DocumentBatchGroupCreator
} from "./grouped_document_browser_model";
import { History } from "react-router";
import {
  addToIgnoredItems,
  maybePrefetchNextFlowModeItem,
  isInNewFlowMode
} from "./flow_mode/flow_mode_service";
import { isAuditMode } from "./index_audit_split_mode";
function quotedBody(email) {
  var prefix = "\n\n\nat " + moment(email.created_at).format("LLL") + email.sender_address + " wrote:\n";
  return prefix + _.map(s.lines(email.text_body), function(line) {
    return "> " + line;
  }).join("\n");
}
function exceptionedItems(state) {
  return state.email.parent.exceptioned_items || [];
}
function carrierInvoice(state) {
  return state.load && state.load.carrier_invoices[0];
}
function carrier(state) {
  return CarrierService.getCarrierOrUnknown(carrierInvoice(state).carrier_id);
}
function payment(state) {
  const result = {};
  const invoice = carrierInvoice(state);
  result.payOn = invoice.date_to_pay || CarrierInvoiceHelper.paymentDueOn(invoice);
  result.amount = invoice.amount_to_pay || invoice.source_invoice_amount;
  return result;
}
function initialSelectedComponent(state) {
  if (possibleMessageBrowserComponent(state)) {
    return "Messages";
  }
}
function possibleMessageBrowserComponent(state) {
  const invoice = state.factorInvoice || carrierInvoice(state);
  const email = state.email;
  let emails;
  if (invoice) {
    emails = invoice.email_messages || invoice.emails || [];
  } else {
    if (email) {
      emails = _.sortBy([email].concat(email.parent_emails), "created_at").reverse() || [];
    }
  }
  if (emails) {
    if (emails.length > 0) {
      return {
        label: "Messages",
        component: EmailHelper.emailMessages(emails)
      };
    }
  }
}
function additionalBrowserComponents(state) {
  return _.compact([
    possibleMessageBrowserComponent(state),
    activityBrowserComponent(state)
  ]);
}
function activityBrowserComponent(state) {
  return {
    label: "Activity",
    component: ActivityStreamHelper.invoiceActivity(
      invoiceActivityItems(state)
    )
  };
}
function invoiceActivityItems(state) {
  if (state.factorInvoice) {
    return state.factorInvoice.activity_items || [];
  } else {
    return [];
  }
}
function hasDocuments(state) {
  return state.newDocumentsModel;
}
function emailInstructions(state) {
  if (!state.sendingEmail) {
    if (state.newDocumentBatch) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, "Review the email for this load. When done, you can view the original email or process the new documents to continue.");
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, "Review the email for this load. When finished you can respond or view the original email to continue.");
    }
  }
}
function emailChainWithoutDocuments(state) {
  return !state.originalDocumentBatchId && !state.newDocumentBatch;
}
function carrierInvoiceApproved(state) {
  return carrierInvoice(state) && carrierInvoice(state).state === "approved";
}
var ReplyView = React.createClass({
  mixins: [EmailForwarderMixin, History],
  // LIFECYCLE
  getInitialState: function() {
    return { loading: true };
  },
  componentWillMount: function() {
    var id = _.last(this.props.location.pathname.split("/")), component = this;
    emailService.getWithId(id, true).then(function(email) {
      component.setState({ email });
      var loadStateId = component.loadStateIdFromEmail(email), loadPromise;
      const exceptions = _.where(
        _.flatten(
          _.map(email.parent_emails, (email2) => {
            return email2.exceptioned_items;
          })
        ),
        { owner_type: "FactorInvoice" }
      );
      const exception = exceptions && exceptions[0];
      if (loadStateId) {
        loadPromise = component.loadLoadInformation(loadStateId);
      } else if (exception && exception.owner_type == "FactorInvoice") {
        loadPromise = component.loadFactorInvoice(exception.owner_id);
      } else {
        loadPromise = component.loadOriginalDocumentBatch(email);
      }
      var batch = email.document_batch;
      var newDocs = batch ? component.loadNewDocuments(batch.id) : true;
      Promise.all([loadPromise, newDocs]).then(function() {
        component.setState({ loading: false });
      });
    });
  },
  componentDidMount() {
    maybePrefetchNextFlowModeItem(this.props.location);
  },
  // STATE
  pageSelected: function() {
    this.forceUpdate();
  },
  typeUpdated: function() {
    this.forceUpdate();
  },
  addDocumentsToInvoiceAndGoToIndexer: function() {
    var component = this;
    if (component.state.newDocumentsModel) {
      var docs = component.state.newDocumentsModel.activeDocuments();
      var carrierId = component.state.email.document_batch_carrier_id;
      ApiService.addErrorHandler(
        // TODO: use fetch instead
        // eslint-disable-next-line no-restricted-syntax
        $.ajax({
          url: "/api/documents/assign_documents_to_new_or_existing_invoice",
          data: {
            load_state_id: component.state.load.id,
            carrier_invoice_id: carrierInvoice(this.state).id,
            carrier_id: carrierId,
            document_ids: _.pluck(docs, "id")
          },
          method: "post"
        }).then(function(result) {
          DataStoreService.updateStores(result);
          component.goToIndexer();
        }),
        null,
        { caller: "ReplyView.addDocumentsToInvoiceAndGoToIndexer" }
      );
    } else {
      component.goToIndexer();
    }
  },
  goToIndexer: function() {
    if (this.state.newDocumentBatch) {
      const docs = this.state.newDocumentBatch.documents;
      if (_.every(docs, (doc) => {
        return doc.type;
      })) {
        this.goToLoad();
      } else {
        this.goToNewDocumentsBatch();
      }
    } else {
      this.goToLoad();
    }
  },
  loadFactorInvoice: function(factorInvoiceId) {
    FactorInvoicesService.getWithId(factorInvoiceId).then((factorInvoice) => {
      this.setState({ factorInvoice });
    });
  },
  loadLoadInformation: function(loadStateId) {
    var component = this;
    return LoadsService.forceGetLoad(loadStateId).then(function(load) {
      component.setState({ load });
      return DocumentsService.getDocumentBatches(load.document_batch_ids).then(
        function(batches) {
          var loadModel = new GroupedDocumentBrowserModel(
            new DocumentBatchGroupCreator(batches, function(doc) {
              return _.first(doc.data.load_state_ids) === load.id;
            })
          );
          component.setState({ loadModel });
        }
      );
    });
  },
  loadOriginalDocumentBatch: function(email) {
    var component = this;
    const exceptionedItem = exceptionedItems(this.state)[0];
    if (exceptionedItem && exceptionedItem.owner_type === "DocumentGroup" && exceptionedItem.completed_at !== void 0) {
      return $.get("/api/document_groups/" + exceptionedItem.owner_id).then(
        (data) => {
          component.setState({
            originalDocumentGroupId: data.document_group.id,
            originalDocumentBatchId: data.document_group.document_batch_id
          });
        }
      );
    }
  },
  loadStateIdFromEmail: function(email) {
    if (email.load_states.length > 0) {
      return email.load_states[0].id;
    }
    if (email.parent) {
      return this.loadStateIdFromEmail(email.parent);
    }
  },
  loadNewDocuments: function(batchId) {
    var component = this;
    return DocumentsService.getDocumentBatch(batchId).then((batch) => {
      var newDocumentsModel = new GroupedDocumentBrowserModel(
        new GroupIDGroupCreator(batch.documents, batch.document_groups),
        _.property("type")
      );
      var documentIndexerService = new DocumentIndexerService(
        batch,
        DataStoreService,
        Api.Account,
        this.props.location
      );
      component.setState({
        newDocumentBatch: batch,
        newDocumentsModel,
        documentIndexerService
      });
    });
  },
  startMarkingComplete: function() {
    this.setState({ markingComplete: true });
  },
  cancelMarkingComplete: function() {
    this.setState({ markingComplete: false });
  },
  doneMarkingComplete: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  goToNewDocumentsBatch: function() {
    this.history.pushState(
      null,
      "/index-document-batches/" + this.state.newDocumentBatch.id,
      DashboardReturnParams(this.props.location)
    );
  },
  processOriginalDocuments: function() {
    const dashboardParams = _.tap(
      DashboardReturnParams(this.props.location),
      (params) => {
        if (this.state.originalDocumentGroupId) {
          params["group_id"] = this.state.originalDocumentGroupId;
        }
      }
    );
    this.history.pushState(
      null,
      "/index-document-batches/" + this.state.originalDocumentBatchId,
      dashboardParams
    );
  },
  goToFactorInvoice: function() {
    this.history.pushState(
      null,
      "/factor_invoices/" + this.state.factorInvoice.id,
      {
        emailId: this.state.email.id,
        onDone: this.props.location.query.onDone,
        filters: this.props.location.query.filters
      }
    );
  },
  goToLoad: function() {
    this.history.pushState(null, "/loads/" + this.state.load.id, {
      fromReply: true,
      emailMessageId: this.state.email.id,
      onDone: this.props.location.query.onDone,
      filters: this.props.location.query.filters
    });
  },
  // RENDER
  render: function() {
    return /* @__PURE__ */ React.createElement(
      Blocker,
      {
        "data-component": "ReplyView",
        modalView: this.possibleEmailForwarder(this.state.email) || this.possibleMarkComplete(this.state.email)
      },
      /* @__PURE__ */ React.createElement("div", { className: "reply-view__container" }, /* @__PURE__ */ React.createElement(WaitingSpinner, { when: this.state.loading }, /* @__PURE__ */ React.createElement("div", { className: "row general-container reply-container" }, this.content())))
    );
  },
  content: function() {
    if (this.state.email) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "document-indexer__header" }, /* @__PURE__ */ React.createElement(
        IndexerHeader,
        {
          email: this.state.email,
          canMarkComplete: !hasDocuments(this.state),
          markComplete: this.startMarkingComplete,
          actions: this.actions(),
          load: this.state.load ? this.state.load.load : null
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "reply-view__main-body row" }, /* @__PURE__ */ React.createElement("div", { className: "small-10 column reply-view__main-areas" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "small-5 column reply-view__work-area" }, this.documentAreaOrLoadArea()), /* @__PURE__ */ React.createElement("div", { className: "small-5 column reply-view__documents-area" }, this.emailOrDocuments())))), /* @__PURE__ */ React.createElement("div", { id: "presence" }, /* @__PURE__ */ React.createElement(
        PresenceList,
        {
          location: this.props.location,
          emailId: this.state.email.id
        }
      )));
    }
  },
  actions: function() {
    const actions = [["Forward Email", this.forwardEmail]];
    const location = this.props.location;
    if (Api.Account.indexAuditSplitEnabled() && isAuditMode(location) && isInNewFlowMode(location.query.onDone)) {
      actions.push(["Next Item", this.skipReply, "next-control"]);
    }
    return actions;
  },
  skipReply: function() {
    addToIgnoredItems("email_ids", this.state.email.id);
    ToDashboardWithFilters(this.props.location, this.history);
  },
  documentAreaOrLoadArea: function() {
    if (this.state.load && !this.state.sendingEmail) {
      return this.loadInfoOrIdentifier();
    } else {
      return /* @__PURE__ */ React.createElement("div", null, this.possibleEmailInformation(), this.possibleReplyEmailForm());
    }
  },
  loadInfoOrIdentifier: function() {
    return /* @__PURE__ */ React.createElement("div", null, this.loadInformation());
  },
  loadInformation: function() {
    if (this.state.load) {
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "reply__email-information" }, this.loadInstructions(), this.loadContinueLink(), this.possibleCloseReplyLink(), this.sendEmailLink()), /* @__PURE__ */ React.createElement(
        DocumentInformation,
        {
          model: this.state.loadModel,
          load: this.state.load,
          readOnly: true,
          carrierInvoice: carrierInvoice(this.state),
          carrier: carrier(this.state),
          keyPressNotifier: function(field) {
          },
          showNoteFieldByDefault: false,
          source_invoice_number: carrierInvoice(this.state).source_invoice_number,
          source_invoice_date: carrierInvoice(this.state).source_invoice_date,
          source_invoice_amount: carrierInvoice(this.state).source_invoice_amount
        }
      ), /* @__PURE__ */ React.createElement(
        PaymentInformation,
        {
          load: this.state.load,
          carrier: carrier(this.state),
          canSaveAndMarkAsProcessed: false,
          readOnly: true,
          keyPressNotifier: function(field) {
          },
          payment: payment(this.state),
          carrierInvoice: carrierInvoice(this.state),
          canEditAddress: false
        }
      ), /* @__PURE__ */ React.createElement(
        LoadDetailInformation,
        {
          model: this.state.loadModel,
          load: this.state.load,
          invoice: carrierInvoice(this.state)
        }
      ));
    }
  },
  // Likely dead code
  /* eslint-disable no-undef */
  // eslint-disable-next-line local/prefer-module-level-functions -- dead code, delete rather than hoist
  documentModel: function() {
    return new GroupedDocumentBrowserModel(
      // @ts-ignore
      new DocumentBatchGroupCreator(documentBatches, function(doc) {
        return doc.carrier_invoice_id === invoiceID;
      })
    );
  },
  /* eslint-enable no-undef */
  emailOrDocuments: function() {
    return /* @__PURE__ */ React.createElement(
      DocumentBrowser,
      {
        initialSelectedComponent: initialSelectedComponent(this.state),
        model: this.documentModel,
        additionalComponents: additionalBrowserComponents(this.state)
      }
    );
  },
  possibleEmailInformation: function() {
    if (!this.state.sendingEmail) {
      return /* @__PURE__ */ React.createElement("div", { className: "reply__email-information" }, emailInstructions(this.state), /* @__PURE__ */ React.createElement("div", { className: "reply__buttons" }, this.possibleProcessFactorInvoiceButton(), this.possibleProcessNewDocumentsButton(), this.processOriginalButton(), this.sendEmailLink()));
    }
  },
  possibleProcessNewDocumentsButton: function() {
    if (this.state.newDocumentBatch) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--progress",
          onClick: this.goToNewDocumentsBatch
        },
        "Process New Documents"
      );
    }
  },
  possibleReplyEmailForm: function() {
    if (emailChainWithoutDocuments(this.state) || this.state.sendingEmail) {
      return /* @__PURE__ */ React.createElement(
        ExceptionSender,
        {
          onComplete: this.onComplete,
          defaultEmail: {
            body: quotedBody(this.state.email),
            subject: "Re: " + this.state.email.subject
          },
          markParentComplete: true,
          emailMessageId: this.state.email.id,
          exceptionedItemId: exceptionedItems(this.state)[0] && exceptionedItems(this.state)[0].id,
          parent: this.state.email,
          canCancel: true,
          possibleLoad: this.state.load,
          cancel: this.cancelSendingEmail
        }
      );
    }
  },
  onComplete: function() {
    ToDashboardWithFilters(this.props.location, this.history);
  },
  possibleProcessFactorInvoiceButton: function() {
    if (this.state.factorInvoice) {
      return /* @__PURE__ */ React.createElement("button", { className: "button--progress", onClick: this.goToFactorInvoice }, "Process Documents");
    }
  },
  processOriginalButton: function() {
    if (this.state.originalDocumentBatchId) {
      return this.processOriginalDocumentsButton();
    }
  },
  processOriginalDocumentsButton: function() {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button--progress",
        onClick: this.processOriginalDocuments
      },
      "Process Original Documents"
    );
  },
  loadInstructions: function() {
    var message = this.state.newDocumentBatch ? "process the new documents to continue." : "respond to the email or continue processing.";
    var baseMessage = "Review the email and the information for this load.";
    if (carrierInvoiceApproved(this.state)) {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, baseMessage, "\xA0 The invoice associated with this message has been approved. You can close the email or\xA0", /* @__PURE__ */ React.createElement("a", { onClick: this.goToIndexer }, "view original documents"), ". If you wish to continue the conversation, please use external email.");
    } else {
      return /* @__PURE__ */ React.createElement("div", { className: "alert-box--progress" }, baseMessage, "\xA0 When done, you can ", message);
    }
  },
  startSendingEmail: function() {
    this.setState({ sendingEmail: true });
  },
  cancelSendingEmail: function() {
    this.setState({ sendingEmail: false });
  },
  sendEmailLink: function() {
    if (!hasDocuments(this.state) && !carrierInvoiceApproved(this.state)) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--progress reply-view__send-email-button",
          onClick: this.startSendingEmail
        },
        "Reply To Email"
      );
    }
  },
  loadContinueLink: function() {
    const buttonText = hasDocuments(this.state) ? "Process Documents" : "Continue Processing";
    if (!carrierInvoiceApproved(this.state)) {
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "button--progress",
          onClick: this.addDocumentsToInvoiceAndGoToIndexer
        },
        buttonText
      );
    }
  },
  possibleCloseReplyLink: function() {
    if (carrierInvoiceApproved(this.state)) {
      return /* @__PURE__ */ React.createElement(
        CloseReply,
        {
          emailId: this.state.email.id,
          onComplete: this.doneMarkingComplete
        }
      );
    }
  },
  possibleMarkComplete: function(email) {
    if (this.state.markingComplete) {
      return /* @__PURE__ */ React.createElement(
        MarkEmailCompleteView,
        {
          email,
          onCancel: this.cancelMarkingComplete,
          onMarkCompleteFinished: this.doneMarkingComplete
        }
      );
    }
  }
});
export default ReplyView;
